import { ButtonUnstyled } from '@lifeomic/chroma-react/components/ButtonUnstyled';
import {
  Popover,
  PopoverItem,
} from '@lifeomic/chroma-react/components/Popover';
import { makeStyles } from '@lifeomic/chroma-react/styles';
import React from 'react';
import { useIntl, defineMessages } from 'react-intl';

const useStyles = makeStyles(theme => ({
  root: {
    background: theme.palette.primary.main,
    borderRadius: theme.pxToRem(3),
    color: theme.palette.common.white,
    display: 'inline-block',
    fontSize: theme.pxToRem(12),
    minWidth: theme.pxToRem(18),
    margin: theme.spacing(0, -0.75, 0, 0.75),
    padding: theme.spacing(0.125, 1),
    position: 'relative',
    [theme.breakpoints.down('lg')]: {
      display: 'inline',
    },
    transition:
      'background-color 0.25s ease, color 0.25s ease, opacity 0.25s ease',
    '&:hover, &:focus': {
      backgroundColor: theme.palette.primary[800],
      cursor: 'pointer',
    },
  },
  popover: {
    padding: theme.spacing(1, 0),
  },
  popoverItem: {
    '& + $popoverItem': {
      paddingTop: 0,
    },
  },
}));

const messages = defineMessages({
  popover: {
    id: 'sequenceDetailsPopover.popover',
    defaultMessage: 'Popover',
  },
});

interface SequenceDetailsPopoverProps {
  label?: string;
  items?: Array<React.ReactNode>;
  onClick?: () => void;
}

export const SequenceDetailsPopover: React.FC<SequenceDetailsPopoverProps> = ({
  label,
  items,
  onClick,
  ...rootProps
}) => {
  const { formatMessage } = useIntl();
  const classes = useStyles({});

  return (
    <Popover
      className={classes.popover}
      aria-label={formatMessage(messages.popover)}
      anchorElement={
        <ButtonUnstyled className={classes.root} onClick={onClick}>
          {label}
        </ButtonUnstyled>
      }
      {...rootProps}
    >
      {/* @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks. */}
      {items.map((item, key) => (
        <PopoverItem className={classes.popoverItem} key={key}>
          {item}
        </PopoverItem>
      ))}
    </Popover>
  );
};
